<template>
    <!-- Donation input shown on the payment page. One component for desktop and mobile so both look the same. -->
    <div class="donation-panel" :class="{ stacked }">
        <div class="donation-icon" aria-hidden="true">
            <i class="bi bi-heart"></i>
        </div>
        <div class="donation-text">
            <label class="donation-title" for="donationAmount">Help a family in Need</label>
            <div class="donation-subtitle">Add any amount to cover a family’s annual membership.</div>
        </div>
        <div class="donation-amount">
            <div class="input-group">
                <span class="input-group-text">$</span>
                <CurrencyInput
                    id="donationAmount"
                    placeholder="0.00"
                    inputmode="decimal"
                    @input="event => setDonationAmount(event.target.value)"
                    :value="donationInputField"
                    :options="{ currency: 'USD', currencyDisplay: 'hidden', precision: 2, valueRange: {min: 0} }"
                />
            </div>
        </div>
    </div>
</template>
<script>
import CurrencyInput from './CurrencyInput.vue';
export default {
    name: "DonationPanel",
    props: [
        "donationInputField",
        "setDonationAmount",
        // true on narrow screens: the amount box goes under the text
        "stacked"
    ],
    components: {
        CurrencyInput
    }
}
</script>
<style scoped>
    .donation-panel {
        display: grid;
        grid-template-columns: auto 1fr minmax(180px, 240px);
        align-items: center;
        column-gap: 16px;
        row-gap: 12px;
        padding: 16px 20px;
        background-color: #eef7f6;
        border: 1px solid #cfe7e5;
        border-radius: 10px;
        text-align: left;
    }
    .donation-icon {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background-color: #d7eeec;
        color: #13827e;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.35rem;
    }
    .donation-title {
        display: block;
        font-weight: 600;
        font-size: 1.1rem;
        line-height: 1.3;
        color: #212529;
        margin: 0;
    }
    .donation-subtitle {
        color: #5c6670;
        font-size: 0.95rem;
        line-height: 1.35;
        margin-top: 2px;
    }
    .input-group-text {
        background-color: #ffffff;
        color: #495057;
    }
    .input-group :deep(.form-control) {
        text-align: left;
    }

    /* Narrow screens: icon and text on top, full-width amount box underneath, lined up with the text.
       Applies to the mobile card view (stacked) and to small tablets showing the table view. */
    .donation-panel.stacked {
        grid-template-columns: auto 1fr;
        align-items: start;
        padding: 16px;
    }
    .donation-panel.stacked .donation-amount {
        grid-column: 2;
    }
    .donation-panel.stacked .donation-icon {
        width: 36px;
        height: 36px;
        font-size: 1.1rem;
    }
    @media (max-width: 767px) {
        .donation-panel {
            grid-template-columns: auto 1fr;
            align-items: start;
            padding: 16px;
        }
        .donation-amount {
            grid-column: 2;
        }
        .donation-icon {
            width: 36px;
            height: 36px;
            font-size: 1.1rem;
        }
    }
</style>
